module.exports = __webpack_public_path__ + "static/alto-risco-3d950642b022d4b551af1534a70e6980.png";